import { Clipboard } from "@capacitor/clipboard";
import { Capacitor, registerPlugin } from "@capacitor/core";
import { Device } from "@capacitor/device";
import { Preferences } from "@capacitor/preferences";
import { Share } from "@capacitor/share";
import type { DevicePort, SecureStore } from "./types";

// Android: @capacitor/preferences(allowBackup="false").
const preferencesStore: SecureStore = {
  get: async (key) => (await Preferences.get({ key })).value,
  set: async (key, value) => Preferences.set({ key, value }),
  remove: async (key) => Preferences.remove({ key }),
};

// iOS: Keychain(auth-session 결정, ios.md i3). 앱 내장 플러그인 ios/App/App/SecureStoragePlugin.swift — 설치 후 첫 실행에 이전 설치의 항목을 지운다.
type KeychainPlugin = {
  get(o: { key: string }): Promise<{ value: string | null }>;
  set(o: { key: string; value: string }): Promise<void>;
  remove(o: { key: string }): Promise<void>;
};
const Keychain = registerPlugin<KeychainPlugin>("HamlakSecureStorage");
const keychainStore: SecureStore = {
  get: async (key) => (await Keychain.get({ key })).value ?? null,
  set: async (key, value) => Keychain.set({ key, value }),
  remove: async (key) => Keychain.remove({ key }),
};

export const nativeDevice: DevicePort & { secureStore: SecureStore } = {
  getDeviceId: async () => (await Device.getId()).identifier,
  isInAppBrowser: () => false,
  copy: async (text) => Clipboard.write({ string: text }),
  getInfo: async () => {
    const i = await Device.getInfo();
    return { model: [i.manufacturer, i.model].filter(Boolean).join(" "), os: `${i.operatingSystem} ${i.osVersion}` };
  },
  share: async ({ title, url }) => {
    try {
      await Share.share({ title, url, dialogTitle: title });
      return "shared";
    } catch (e) {
      // 사용자가 공유 시트를 닫으면 플러그인이 "Share canceled" 로 reject 한다(Android·iOS 같은 문구)
      if (e instanceof Error && /cancel/i.test(e.message)) return "dismissed";
      throw e;
    }
  },
  secureStore: Capacitor.getPlatform() === "ios" ? keychainStore : preferencesStore,
};
